export const GET_AR_EFFECTS = "GET_AR_EFFECTS"

export const OPEN_AR_EFFECTS_DIALOG = "OPEN_AR_EFFECTS_DIALOG"

export const CLOSE_AR_EFFECTS_DIALOG = "CLOSE_AR_EFFECTS_DIALOG"

export const CREATE_AR_EFFECT = "CREATE_AR_EFFECT"

export const UPDATE_AR_EFFECT = "UPDATE_AR_EFFECT"

export const DELETE_AR_EFFECT = "DELETE_AR_EFFECT"





